<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span><i>To Catherine Coulter,</i></span></p>
<p class="center"><span><i>Whose talent is exceeded only</i></span></p>
<p class="center"><span><i>By her generosity of spirit and friendship,</i></span></p>
<p class="center"><span><i>Thank you, for every pearl of wisdom.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-dedication.vue?6f1b7c22